import React from 'react'
import createClass from 'create-react-class'
import PropTypes from 'prop-types'
import { Button, ButtonGroup } from 'reactstrap'
import CertificateDates from './CertificateDates'
import CertificateRowCell from './CertificateRowCell'
import CertificateDimensions from './CertificateDimensions'
import { getUserPermissions } from '../../../utils/userPermissions'
import { API_BASE_URL } from '../../../utils/apiConfig'
import ExportWelderCertificateBtn from '../export_welders/ExportWelderCertificateBtn'

const CertificateRow = createClass({
  propTypes: {
    changeParentStateFunction: PropTypes.func,
    dimensionsDictionary: PropTypes.array.isRequired,
    welder_id: PropTypes.number.isRequired,
    form_is_opened: PropTypes.bool,
    certificate: PropTypes.object,
    isApproval: PropTypes.bool,
    noActions: PropTypes.bool,
    merge_by_cert_no: PropTypes.bool
  },
  renderAddBtn() {
    return <Button key='add' color="primary" id="add-new-welder-certificate-btn" title="Add"
      className="float-right"
      onClick={(e) => {
        e.stopPropagation()
        window.scrollTo(0, 0)
        this.props.changeParentStateFunction({ form_is_opened: true, form_welder_id: this.props.welder_id })
      }}>
      <i className="fa fa-plus" />
    </Button>
  },
  renderCertificateRowData() {
    let certificate = this.props.certificate
    let welder_id = this.props.welder_id
    let approvalClassName = this.props.isApproval ? 'text-secondary' : ''
    let welder_last_att = certificate.attachments && certificate.attachments.length > 0 && certificate.attachments[certificate.attachments.length - 1]
    return [
      <td key={`td3_no_${welder_id}`} className={approvalClassName}>
        <b>{certificate.no}</b>
        {welder_last_att && <a href={API_BASE_URL + welder_last_att.url} onClick={e => e.stopPropagation()} target='_blank'>{' '}
          <i className="fa fa-paperclip" /></a>}
      </td>,
      <td key={`td3_${welder_id}`} className={approvalClassName}>
        <b>{this.props.isApproval ? 'Range of qualifications' : certificate.standard.name}</b>
      </td>,
      <td key={`td4_${welder_id}`} className={approvalClassName}>
        <CertificateRowCell id={`welding_processes_${certificate.id}`} data={certificate.welding_processes} />
      </td>,
      <td key={`td5_${welder_id}`} className={approvalClassName}>
        <CertificateRowCell id={`product_types_${certificate.id}`} data={certificate.product_types} />
      </td>,
      <td key={`td6_${welder_id}`} className={approvalClassName}>
        <CertificateRowCell id={`type_of_welds_${certificate.id}`} data={certificate.type_of_welds} />
      </td>,
      <td key={`td6_1_${welder_id}`} className={approvalClassName}>
        <CertificateRowCell id={`material_groups_${certificate.id}`}
          data={certificate.material_groups.length > 0 ? certificate.material_groups : []}
          formatedData={certificate.material_groups.length > 0 ? null :
            (certificate.material_group || []).join(', ')}
        />
      </td>,
      <td key={`td7_${welder_id}`} className={approvalClassName}>
        <CertificateRowCell id={`filler_material_groups_${certificate.id}`} data={certificate.filler_material_groups} />
      </td>,
      <td key={`td8_${welder_id}`} className={approvalClassName}>
        <CertificateRowCell id={`filler_materials_or_type_of_weldings_${certificate.id}`}
          data={certificate.filler_materials.length > 0 ? certificate.filler_materials : certificate.type_of_weldings} />
      </td>,
      <CertificateDimensions
        key={`td_9_10_${welder_id}`}
        tdClassName={approvalClassName}
        dimensionsDictionary={this.props.dimensionsDictionary}
        certificate={certificate}
      />,
      <td key={`td10_${welder_id}`} className={approvalClassName}>
        <CertificateRowCell id={`welding_positions_${certificate.id}`} data={certificate.welding_positions} />
      </td>,
      <td key={`td11_${welder_id}`} className={approvalClassName}>
        <CertificateRowCell id={`weld_details_or_metal_transfers_${certificate.id}`}
          data={certificate.weld_details.length > 0 ? certificate.weld_details : certificate.metal_transfers}
          formatedData={certificate.weld_details.length > 0 ? certificate.weld_detail_sorted : null} />
      </td>,
      <td key={`td12_${welder_id}`}>
        {(certificate.expiration_date || certificate.confirmation_date) && <CertificateDates id={certificate.id}
          expiration_date={certificate.expiration_date}
          confirmation_date={certificate.confirmation_date} />}
      </td>,
      <td key={`td13_${welder_id}`}>
        {certificate.publisher}
      </td>,
      !this.props.noActions && <td key={`td14_${welder_id}`}>
        <ButtonGroup size="sm">
          {!this.props.merge_by_cert_no && [
            !this.props.isApproval && !this.props.form_is_opened && getUserPermissions('wl_welders.certificates.create') &&
            this.renderAddBtn(welder_id),
            !this.props.merge_by_cert_no && !this.props.isApproval && getUserPermissions('wl_welders.certificates.destroy') &&
            <Button key='remove' id="remove-certificate-btn" color="danger" title="Remove"
              onClick={(e) => {
                e.stopPropagation()
                this.props.changeParentStateFunction({ certificate_id_remove: certificate.id })
              }}>
              <i className="fa fa-trash-o" />
            </Button>,
            !this.props.merge_by_cert_no && !this.props.isApproval && getUserPermissions('wl_welders.certificates.update') &&
            <Button key='edit' id="edit-certificate-btn" color="warning" title="Edit" onClick={(e) => {
              e.stopPropagation()
              window.scrollTo(0, 0)
              this.props.changeParentStateFunction({
                form_is_opened: true,
                data_to_edit: certificate,
                form_welder_id: welder_id
              }
              )
            }}>
              <i className="fa fa-edit" />
            </Button>,
            !this.props.merge_by_cert_no && !this.props.isApproval && getUserPermissions('wl_welders.certificates.add_confirmation') &&
            <Button key='confirmation' id="add-certificate-confirmation-btn" color="success" title="Add confirmation"
              onClick={(e) => {
                e.stopPropagation()
                this.props.changeParentStateFunction({ certificate_confirmation_id: certificate.id })
              }}>
              <i className="fa fa-hourglass-start" />
            </Button>
          ].filter(Boolean)}

          {!this.props.isApproval && <ExportWelderCertificateBtn certificate_id={Number(certificate.id)}
            merge_by_cert_no={this.props.merge_by_cert_no} />}
        </ButtonGroup>
      </td>
    ].filter(Boolean)
  },
  render() {
    if (this.props.certificate) {
      return this.renderCertificateRowData()
    } else {
      return ([
        <td key={`td3_${this.props.welder_id}`} colSpan="12">&nbsp;</td>,
        (!this.props.form_is_opened && <td key={`td4_${this.props.welder_id}`}>
          {getUserPermissions('wl_welders.certificates.create') && this.renderAddBtn()}</td>) || <td key={`td4_${this.props.welder_id}`}>&nbsp;</td>]
      )
    }
  }
})

export default CertificateRow



// WEBPACK FOOTER //
// ./src/components/Welders/helpers/CertificateRow.js